module.exports = __webpack_public_path__ + "img/light.93f34aa2.svg";